import React, { memo } from "react";
import Modal from "./Modal";
import "./styles/scss/Kf.scss";

const arr = [
	{
		name: "平台客服QQ",
		url: "http://www.wanjiayizhan.com",
		number: "5599751574",
	},
	{
		name: "游戏账号客服QQ",
		url: "http://www.wanjiayizhan.com",
		number: "55997515745",
	},
];

function App(props) {
	const { isShow, onClose } = props;

	return (
		<Modal
			className="popup-kf"
			visible={isShow}
			onClose={onClose}
			style={{ paddingLeft: 37 }}
		>
			<div className="popup-content">
				{arr.map((ele, index) => (
					<div
						key={index}
						onClick={() => {
							window.mbQuery?.openBrowser(ele.url);
						}}
					>
						<div></div>
						<p>{ele.name}</p>
						<p>{ele.number}</p>
					</div>
				))}
			</div>
			<div className="popup-tips">服务时间：周一至周五9:00点—18:00点</div>
		</Modal>
	);
}

export default memo(App);
